import createStyled from './createStyled';
const styled = createStyled();
export default styled;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/system/esm/styled.js
// module id = 356
// module chunks = 31